import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { translation } from '../../../../utils/helpers'

// Actions
import { getBookingTime, saveBookingTime } from '../../../../actions/bookingTime'
import { triggerPopup } from '../../../../actions/backdrop'

import Portal from '../../Portal'
import ConfirmOk from '../../ConfirmOk'

import DeliveryDateChangeModal from '../../../modals/DeliveryDateChangeModal'

// Utils
import { renderTimeOnly } from '../../../../utils/time'
import EventEmitter from '../../../../utils/events'

class BookingTimesWrapper extends Component {

  constructor (props) {
    super(props)
    this.state = {
      Paint: undefined,
      Body: undefined,

      NeedChangeReason: false,
      ChangeReasonInfo: {},

      isLoading: false,
      showPopup: false,
      ModalInfoKey: null,
      ErrorKey: null,

      EditedBookingTime: {
        Date: '',
        Time: '',
        Department: 0,
        OrderId: 0,
        BookingTimeType: null,
        LeadTime: null
      }
    }
    this.handleSocket = this.handleSocket.bind(this)
    this.renderDateChangeModal = this.renderDateChangeModal.bind(this)
    this.handleBookinTimesEmitter = this.handleBookinTimesEmitter.bind(this)
  }

  componentDidMount () {
    this.getBookingTimes()

    EventEmitter.removeListener('ORDER_SOCKET', this.handleSocket)
    EventEmitter.addListener('ORDER_SOCKET', this.handleSocket, this)

    EventEmitter.removeListener('UPDATE_BOOKINGTIMES', this.handleBookinTimesEmitter)
    EventEmitter.addListener('UPDATE_BOOKINGTIMES', this.handleBookinTimesEmitter, this)
  }

  componentWillUnmount () {
    EventEmitter.removeListener('ORDER_SOCKET', this.handleSocket)
    EventEmitter.removeListener('UPDATE_BOOKINGTIMES', this.handleBookinTimesEmitter)
  }

  handleSocket (json) {
    if (json.Type === 'ORDER_UPDATE' && json.Data.Id === this.props.OrderId) this.getBookingTimes()
  }

  handleBookinTimesEmitter () {
    this.getBookingTimes()
  }

  getBookingTimes () {
    this.props.getBookingTime(this.props.OrderId).then((res) => {
      this.setState({
        Body: res.data.Body,
        Paint: res.data.Paint
      })
    }, (error) => {
      console.log(error)
    })
  }

  saveBookingTime (onSuccess) {
    // this.renderModalMessage()
    this.setState({
      isLoading: false,
      showPopup: false
    })
    this.props.saveBookingTime(this.state.EditedBookingTime).then((res) => {
      const { ModalInfoKey, ErrorKey, NeedChangeReason } = res.data
      let textKey, showPopup
      if (!NeedChangeReason) {
        if (ModalInfoKey) {
          textKey = ModalInfoKey
          showPopup = true
        }
        if (ErrorKey) {
          textKey = ErrorKey
        }
      }

      if (NeedChangeReason) {
        this.props.triggerPopup(true)
      }

      this.setState({
        Body: res.data.Body,
        Paint: res.data.Paint,
        isLoading: false,
        textKey: textKey,
        showPopup: showPopup,
        NeedChangeReason,
        ChangeReasonInfo: res.data.ChangeReasonInfo
      }, () => {
        if (NeedChangeReason) {
          // window.toastr.info(translation('@Need more info'), translation('@Info'))
        } else if (!ErrorKey) {
          // window.toastr.success(translation(''), translation('13424'))
          if (typeof onSuccess === 'function') onSuccess()
          if (typeof this.props.onUpdated === 'function') this.props.onUpdated()
        } else {
          window.toastr.error(translation(ErrorKey), translation('216'))
        }
      })
    }, () => {
      window.toastr.error(translation('960'), translation('216'))
    })
  }

  onConfirm () {
    this.onPortalClose()
  }
  onPortalClose () {
    this.setState({
      showPopup: false
    })
  }
  renderPopupMessage () {
    const { showPopup, textKey } = this.state
    return (
      <div>
        {showPopup && (
          <Portal className='confirm_popup' onPortalClose={this.onPortalClose.bind(this)}>
            <ConfirmOk
              headingText={() => { return translation('534') }}
              renderText={() => { return translation(textKey) }}
              confirm={this.onConfirm.bind(this)} />
          </Portal>
        )}
      </div>
    )
  }

  renderDateChangeModal () {
    if (!this.state.NeedChangeReason) return null

    const onClose = () => {
      this.props.triggerPopup(false)
      this.setState({ NeedChangeReason: false })
    }
    const updateFromDeliveryTime = data => {
      this.setState({
        NeedChangeReason: false,
        EditedBookingTime: {
          ...this.state.EditedBookingTime,
          Date: data.NewDate,
          Time: renderTimeOnly(data.NewDate),
          ChangeReason: {
            ChangeReasonComment: data.DeliveryChangeComment,
            CommentApplyToInvoice: data.CommentApplyToInvoice,
            CommentShowToCustomer: data.CommentShowToCustomer,
            ChangeReason: data.DeliveryChangeReason
          }
        }
      }, () => {
        this.saveBookingTime()
        this.props.triggerPopup(false)
      })
    }

    const formatTime = (time) => {
      return time.substring(0, 5)
    }

    const { OldBookingTime, NewBookingTime, CompanyName, CustomerName } = this.state.ChangeReasonInfo
    return (
      <DeliveryDateChangeModal
        show
        onClose={onClose}
        onSave={updateFromDeliveryTime}
        oldDate={OldBookingTime.Date}
        newDate={NewBookingTime.Date}
        clientName={CustomerName}
        shopName={CompanyName}
        times={NewBookingTime.ValidTimes.map(x => formatTime(x))}
      />
    )
  }

  render () {
    return (
      <div>
        {this.props.children(this.state, (state, callBack) => this.setState({...this.state, ...state}, callBack), callBack => this.saveBookingTime(callBack))}
        {this.renderPopupMessage()}
        {this.renderDateChangeModal()}
      </div>
    )
  }
}

BookingTimesWrapper.propTypes = {
  OrderId: PropTypes.number.isRequired,
  children: PropTypes.func.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}
export default connect(mapStateToProps, {
  getBookingTime,
  saveBookingTime,
  triggerPopup
})(BookingTimesWrapper)



// WEBPACK FOOTER //
// ./src/app/shared/components/BookingTimes/Wrapper/index.js